import React, { useState, useEffect, useRef } from 'react';
import Logo from "../images/logo.svg";
import { SelectPicker, Toggle, Whisper, Popover, Button,Tooltip, Placeholder } from "rsuite";
import 'rsuite/SelectPicker/styles/index.css';
import iconExportExcel from "../images/iconExportExcel.svg";
import { Link  } from "react-router-dom";
import Sidebar from '../component/Sidebar';
import { Chart } from 'primereact/chart';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'


const StatusData = ['Halal', 'Not Halal', 'Doughtful', 'Uncover'].map(
    item => ({ label: item, value: item })
);
const StatusManualDisableData = ['Sharia ETFs', 'Disabled ETFs'].map(
    item => ({ label: item, value: item === 'Sharia ETFs' ? 0 : 1 })
);

function ETFAnalytics() {


        const [tabName, setTabName] = useState('ETF Analytics');
    
        useEffect(() => {
          document.title = tabName;
        }, [tabName]);

         const toast = useToast()
         const toastIdRef = React.useRef()
         
    const [isLoadingGraph, setLoadingGraph] = useState(true); // State to manage loading state
    const [isLoadingProfile, setLoadingProfile] = useState(true); // State to manage loading state
    const [isLoadingMismatch, setLoadingMismatch] = useState(true); // State to manage loading state
    const [isLoadingSymbol, setLoadingSymbol] = useState(true); // State to manage loading state
    const apiEndPoint = process.env.REACT_APP_ETF_API_ENDPOINT;
    const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT;
    const userid = localStorage.getItem("novauserid");
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [countryData, setCountryData] = useState([]);
    const [countryCode, setCountryCode] = useState("US");
    const [dataHoldings, setDataHoldings] = useState([]);
    const [dataProfile, setDataProfile] = useState([]);
    const [manualStatusId, setManualStatusId] = useState(0);
    const [etfList, setEtfList] = useState([]);
    const [etfDesc, setEtfDesc] = useState("");
    const [etfCount, setEtfCount] = useState("");
    const [complianceData, setComplianceData] = useState([]);
    const [novaComplianceId, setNovaComplianceId] = useState("");
    const [musaffaComplianceId, setMusaffaComplianceId] = useState("");
    const [mismatchData, setMismatchData] = useState([]);
    const [mismatchEtfCount, setMismatchEtfCount] = useState([]);
    const [updateAPI, setUpdateAPI] = useState("");

    const [etfloading, setETFloading] = useState(false);
    const [mismatchloading, setMismatchloading] = useState(false);

    //         labels: ["CMPT", "NCMPT", "DBTF", "UNCVD",],
    //         datasets: [
    //             {
    //                 label: "",
    //                 data: [100, 80, 60, 40],
    //                 backgroundColor: ["#0A8F43", "#BD000B", "#E4AF28", "#4B4B4B"], // Custom bar colors
    //                 borderWidth: 0, // Border thickness
    //                 barThickness: 30,
    //                 borderRadius: { topLeft: 10, topRight: 10 },
    //             },

    //         ],
    //     };

    //     const options = {
    //         responsive: true,
    //         maintainAspectRatio: false,
    //         plugins: {
    //             legend: {
    //                 position: "top",
    //                 display: false,
    //             },
    //         },
    //         scales: {
    //             x: {
    //                 grid: {
    //                     display: false, // Remove horizontal grid lines
    //                 },
    //                 ticks: {
    //                     color: "#767676",
    //                     font: {
    //                         size: 13, // Adjust font size
    //                         family: "Inter", // Change font family
    //                         weight: "bold", // Set font weight
    //                     },
    //                 },
    //             },
    //             y: {
    //                 grid: {
    //                     drawTicks: false, // Hide tick marks
    //                     color: (context) => {
    //                         const index = context.tick.value;
    //                         return index === 0 || index === 40 || index === 80 ? "#E0E0E0" : "transparent"; // Keep only 3 lines
    //                     },
    //                 },
    //                 ticks: {
    //                     stepSize: 40, // Adjust this value to control grid line spacing
    //                     color: "#767676",
    //                     font: {
    //                         size: 12, // Adjust font size
    //                         family: "Inter", // Change font family
    //                         weight: "bold", // Set font weight
    //                     },
    //                 },
    //                 suggestedMin: 0,
    //                 suggestedMax: 120, // Adjust based on your data range
    //             },
    //         },
    //     };

    //     setChartData(data);
    //     setChartOptions(options);
    // }, []);

    //Country API
 
     // Compliance List
  useEffect(() => {
    const fetchComplianceStatusList = async () => {
      const url = `${apiEndPoint1}/get_compliance_status`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedComplianceStatusData = data.data.map((complaince) => ({
          label: complaince.name,
          value: complaince.id,
        }));

        setComplianceData(formattedComplianceStatusData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchComplianceStatusList();
  }, []);

  const handleNovaComplianceChange = (value) => {
    setNovaComplianceId(value);
  };
  
  const handleMusaffaComplianceChange = (value) => {
    setMusaffaComplianceId(value);
  };

  


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiEndPoint}/etf_shariastatus_graph`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ data: { country: countryCode } })
                });

                const result = await response.json();
                const apiData = result.data.data;

                // Set chart data dynamically
                const data = {
                    labels: apiData.label,  // Dynamic labels from API
                    datasets: [
                        {
                            label: "",
                            data: apiData.data,  // Dynamic data from API
                            backgroundColor: apiData.colorcode,  // Dynamic colors from API
                            borderWidth: 0,
                            barThickness: 30,
                            borderRadius: { topLeft: 10, topRight: 10 },
                        },
                    ],
                };

                // Set chart options
                const options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { position: "top", display: false },
                    },
                    scales: {
                        x: {
                            grid: { display: false },
                            ticks: {
                                color: "#767676",
                                font: { size: 13, family: "Inter", weight: "bold" },
                            },
                        },
                        y: {
                            grid: {
                                drawTicks: false,
                                color: (context) => {
                                    const index = context.tick.value;
                                    return index === 0 || index === 40 || index === 80 ? "#E0E0E0" : "transparent";
                                },
                            },
                            ticks: {
                                stepSize: 40,
                                color: "#767676",
                                font: { size: 12, family: "Inter", weight: "bold" },
                            },
                            suggestedMin: 0,
                            suggestedMax: Math.max(...apiData.data) + 20, // Adjust based on max value
                        },
                    },
                };

                setChartData(data);
                setChartOptions(options);
            } catch (error) {
                console.error("Error fetching chart data:", error);
            }
        };

        fetchData();
    }, [countryCode]);

    useEffect(() => {
            const fetchCountryList = async () => {
              const url = `${apiEndPoint}/get_country_list_etf`;
              const payload = {
                data: {
                  user_id: userid // Replace with the actual user_id if dynamic
                }
              };
          
              try {
                const response = await fetch(url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                });
          
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
          
                const responseData = await response.json();
                const data = responseData.data; // Flatten the response
        
                const formattedCountryData = data.data.map((country) => ({
                  label: country.country_name,
                  value: country.country_code,
                }));
        
                setCountryData(formattedCountryData);
          
              } catch (error) {
                toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });

                return false;
              }
            };
          
            fetchCountryList();
          }, []);


     const handleCountryChange = (value) => {
            setCountryCode(value);
     };


     useEffect(() => {
        setLoadingProfile(true);
        const fetchData = async () => {
          try {
            const response = await fetch(`${apiEndPoint}/etf_analytics`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                data: {
                  user_id: userid,
                },
              }),
            });
            
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
    
            const result = await response.json();
            if(result.data.status == "success")
            {
                setLoadingProfile(false);
                setDataHoldings(result.data.data.holdings);    
                setDataProfile(result.data.data.profile)
            }
            else if(result.data.status == "error"){
                setLoadingProfile(false);
                toastIdRef.current = toast({ description: result.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
          } catch (error) {
            setLoadingProfile(false);
            toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });

           // setError(error.message);
          } finally {
           // setLoading(false);
          }
        };
    
        fetchData();
      }, []);

      useEffect(() => {

        setLoadingMismatch(true);

        const fetchData = async () => {
          try {
            const response = await fetch(`${apiEndPoint}/etf_shariastatus_mismatch`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                data: {
                    musaffa: musaffaComplianceId,
                    nova: novaComplianceId,
                    user_id:userid,
                },
              }),
            });
            
            if (!response.ok) {
                
              throw new Error("Network response was not ok");
            }
    
            const result = await response.json();
            if(result.data.status == "success")
            {
                setLoadingMismatch(false);
                setMismatchEtfCount(result.data.total);
                setMismatchData(result.data.data);    
            }
            else if(result.data.status == "error"){
                setLoadingMismatch(false);
                toastIdRef.current = toast({ description: result.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
          } catch (error) {
            setLoadingMismatch(false);
            toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });

           // setError(error.message);
          } finally {
           // setLoading(false);
          }
        };
    
        fetchData();
      }, [novaComplianceId,musaffaComplianceId,updateAPI]);


      useEffect(() => {
        setLoadingSymbol(true);
      const disableEtfs = async () => {
        try {
            const response = await fetch(`${apiEndPoint}/manual_disable_etfs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        flag: manualStatusId.toString()
                    }
                })
            });

    
            // Check if the response is successful
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const result = await response.json();
    
            // Handle success response
            if (result.data && result.data.status === "success") {
                setLoadingSymbol(false);
                setEtfList(manualStatusId === 0 ? result.data.data.sharia_approved_etfs : result.data.data.disabled_etfs);
                setEtfDesc(result.data.data.description);
                setEtfCount(result.data.data.total_count);
            }  if (result.data && result.data.status === "error")  {
                setLoadingSymbol(false);
                toastIdRef.current = toast({ description: result.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
    
        } catch (error) {
            // Handle network or API errors
            setLoadingSymbol(false);
            toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
    };
    disableEtfs();
    }, [manualStatusId]);
    
   

    const handleManualStatusChange = (value) => {
        setManualStatusId(value);
 };


   const [openDeletePopover, setOpenDeletePopover] = useState(null);
   const [publishSymbol, setPublishSymbol] = useState("");

   const handlePublishConfirm = (item) => {
    // console.log(`Publish report with Symbol: ${Symbol}`);
  
      // Prepare the data to be sent in the API request
      const requestData = {
          data: {
              user_id: userid, // Replace with actual user_id if needed
              symbol: item.symbol, // Use the symbol passed to the function
              publish: "true"
          }
      };
  
      // Make the API call using fetch
      fetch(`${apiEndPoint}/publish_etf_profile`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
      })
      .then((response) => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json(); // Parse the JSON from the response
      })
      .then((data) => {
          // Check if the status is success
          if (data.data && data.data.status === 'success') {
            console.log(data.data.message); // Log the success message
            //alert(data.data.message); // Optionally, show a success alert to the user
            setUpdateAPI("success")
            toastIdRef.current = toast({ description: data.data.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
        } else {
            toastIdRef.current = toast({ description: data.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            console.error('Unexpected response format:', data);
        }
      })
      .catch((error) => {
          //console.error('Error:', error);
          toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          // Handle the error, e.g., show an error message
      });
  
      setOpenDeletePopover(null); // Close the popover after confirmation
  };
  
  const handleCheckboxChange = (e, item) => {
    setPublishSymbol(item.Symbol)
    //e.stopPropagation(); // Prevents the event from bubbling up
    // Handle the checkbox change here
    // You can check e.target.checked to see if it's checked or unchecked
};



const handleETFSymbolDownload = async () => {
    try {
     setETFloading(true);
      const response = await fetch(`${apiEndPoint}/exportEtfs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            flag: manualStatusId,
          },
        }),
      });

      if (!response.ok) {
        setETFloading(false);
        throw new Error("Network response was not ok");
      }

      // Excel file के रूप में response को blob में बदलें
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // एक hidden <a> टैग बनाकर फ़ाइल डाउनलोड करें
      const a = document.createElement("a");
      a.href = url;
      a.download = "exported_etf.xlsx"; // फ़ाइल का नाम
      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setETFloading(false);
    } catch (error) {
        setETFloading(false);
      console.error("Download failed:", error);
    }
};

const handleETFMismatchDownload = async () => {
    try {
        setMismatchloading(true);
      const response = await fetch(`${apiEndPoint}/exportMismatchedShariahStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            nova_status: novaComplianceId,
            musaffa_status:musaffaComplianceId
          },
        }),
      });

      if (!response.ok) {
        setMismatchloading(false);
        throw new Error("Network response was not ok");
      }

      // Excel file के रूप में response को blob में बदलें
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // एक hidden <a> टैग बनाकर फ़ाइल डाउनलोड करें
      const a = document.createElement("a");
      a.href = url;
      a.download = "mismatched_etf.xlsx"; // फ़ाइल का नाम
      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setMismatchloading(false);
    } catch (error) {
        setMismatchloading(false);
      console.error("Download failed:", error);
    }
};
    

    return (
        <>
            <Sidebar />
            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} />
                    </div>
                    <div className='brand_name'>ETF Analytics</div>
                </div>
            </div>
            <ChakraProvider>
            <Wrap>
       

            <div className="container-fluid content pb-5 pt-3">
                {/* <h2 className='title_main_dashboard'>Welcome Back!</h2> */}
                <div className='dashboard_row mt-3'>
                    <div className='dashboard_user_col dashboard_etf_static_col'>
                        <h5>ETF Analysis Statistics</h5>
                        <div className='dashboard_etf_static_graph'>


                            <div className='dropdown_style'>
                                <SelectPicker
                                    data={countryData}
                                    searchable={false}
                                    style={{ width: 190 }}
                                    placeholder="Select By Country"
                                    onChange={handleCountryChange}
                                    value={countryCode}
                                
                                />
                            </div>
                            <div className='bar_chart_col'>
                                {/* <ul className='chart_custom_legend'>
                                    <li><span className='custom_legend legend_cmpt'></span>CMPT:<span className='clagend_vaue'>100</span></li>
                                    <li><span className='custom_legend legend_ncmpt'></span>NCMPT:<span className='clagend_vaue'>80</span></li>
                                    <li><span className='custom_legend legend_dbtf'></span>DBTF:<span className='clagend_vaue'>60</span></li>
                                    <li><span className='custom_legend legend_uncvd'></span>UNCVD:<span className='clagend_vaue'>40</span></li>
                                </ul> */}
                                <ul className='chart_custom_legend'>
                                    {chartData.labels?.map((label, index) => (
                                        <li key={label}>
                                            <span className={`custom_legend legend_${label.toLowerCase()}`}></span>
                                            {label}: <span className='clagend_vaue'>{chartData.datasets?.[0]?.data[index]}</span>
                                        </li>
                                    ))}
                                </ul>
                                <Chart type="bar" data={chartData} options={chartOptions} />

                                <h6>Compliance Status</h6>
                            </div>
                      

                        </div>
                    </div>

                    <div className='dashboard_etf_missing_data'>
                        <h5>ETFs Missing Data Statistics</h5>
                        <h6>This contains all the information related to the Nova system</h6>
                        {isLoadingProfile && ( <Placeholder.Grid rows={9} columns={4} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}

{/* Table */}
{!isLoadingProfile && (
	

	
                        <>
                        <div className='etf_missing_data_profile_wrap'>
                            <h4>ETFs Profile</h4>
                            <div className='etf_missing_data_profile_row'>
                                <div className='etf_missign_data_col etf_missign_data_profile_col'>
                                    <p>With 0 <br />Holdings</p>
                                    <Link to={`/profileDetails/zeroholdings`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataProfile.zero_holdings_etf}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_profile_col'>
                                    <p>Profile AUM <br />Missing</p>
                                    <Link to={`/profileDetails/missingaum`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataProfile.aum_missing_etf}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_profile_col'>
                                    <p>Converted <br />ETF</p>
                                    <Link to={`/profileDetails/convertedetf`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataProfile.converted_etf}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_profile_col'>
                                    <p>Count Fail <br />by CBA</p>
                                    <Link to={`/profileDetails/failbycba`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataProfile.fail_by_cba_status}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_profile_col'>
                                    <p>Fail by <br />Data Error</p>
                                    <Link to={`/profileDetails/dataerror`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataProfile.fail_by_data_error}</h3>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className='etf_missing_data_profile_wrap'>
                            <h4>ETFs Holdings</h4>
                            <div className='etf_missing_data_profile_row'>
                                <div className='etf_missign_data_col etf_missign_data_holding_col'>
                                    <p>Empty Asset <br />Class</p>
                                    <Link to={`/holdingDetails/emptyAssetClass`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataHoldings.assetType_missing}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_holding_col'>
                                    <p>ETF <br />Value</p>
                                    <Link to={`/holdingDetails/valueMissing`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataHoldings.value_missing}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_holding_col'>
                                    <p>Share <br />Outstanding</p>
                                    <Link to={`/holdingDetails/shareOutstandingMissing`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataHoldings.shares_outstanding_missing}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_holding_col'>
                                    <p>Missing <br />Symbol</p>
                                    <Link to={`/holdingDetails/missingSymbol`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataHoldings.symbol_missing}</h3>
                                    </Link>
                                </div>
                                <div className='etf_missign_data_col etf_missign_data_holding_col'>
                                    <p>Share held <br />by ETF</p>
                                    <Link to={`/holdingDetails/missingShareHeldByETF`} style={{ textDecoration: "none", color: "black", width: 'calc(100% - 24px)', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis', }} >
                                    <h3>{dataHoldings.share_missing}</h3>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        </>
                        	)}  
                    </div>
                </div>

                <div className='dashboard_row mt-3'>
                    <div className='etf_missing_data_table_col'>
                        <div className='mismatched_etf_table_header mb-3'>
                            <h5>Mismatched ETFs</h5>
                            <div className='mismatched_etf_table_header_inner'>
                                <div className='dropdown_style'>
                                    <SelectPicker
                                        data={complianceData}
                                        searchable={false}
                                        style={{ width: 190 }}
                                        placeholder="Short by (NOVA Status)"
                                        onChange={handleNovaComplianceChange}
                                        value={novaComplianceId}
                                    />
                                </div>
                                <div className='dropdown_style'>
                                    <SelectPicker
                                        data={complianceData}
                                        searchable={false}
                                        style={{ width: 205 }}
                                        placeholder="Short by (Musaffa Status)"
                                        onChange={handleMusaffaComplianceChange}
                                        value={musaffaComplianceId}
                                    />
                                </div>
                                <Button className='btn__export_report' onClick={handleETFMismatchDownload} loading={mismatchloading}><img src={iconExportExcel} />Export</Button>
                            </div>
                        </div>
                        <h6 className='total_etf_data'>Total ETFs : {Number(mismatchEtfCount).toLocaleString()}</h6>
                        {isLoadingMismatch && ( <Placeholder.Grid rows={20} columns={4} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}

{/* Table */}
{!isLoadingMismatch && (

                        <div className='company_table_list table_dashboard_company table-responsive mt-3' style={{ maxHeight: 320, overflow: 'auto' }}>
                            <table className='table mismatched_etf_table'>
                                <thead>
                                    <tr>
                                        <th>Actions</th>
                                        <th>ETF Name</th>
                                        <th>NOVA Status</th>
                                        <th style={{ textAlign: "center" }}>Musaffa Status</th>
                                        <th>Publish Date</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {mismatchData.length > 0 ? (
                                        mismatchData.map((item, index) => (
                                            <tr>
                                            <td style={{textAlign:'center'}}>
                     <Whisper
                                 placement="right"
                                 trigger="click"
                                 open={openDeletePopover === item.id}
                                 onClose={() => setOpenDeletePopover(null)}
                                 speaker={
                                     <Popover className="tooltip_form Rsuite_popover" preventOverflow>
                                         <div className="tooltip_form_inner text-center">
                                             <div style={{ fontSize: 20, color: "#141B3C", fontWeight: 600, lineHeight: 1.3 }}>
                                                 Are you sure you want to <br />
                                                {item.Published ? "unpublish" : "publish"} {publishSymbol} report?
                                             </div>
                 
                                             <div className='btn__group mt-5'>
                                                 <a href="#" className='btn__cancel' onClick={() => setOpenDeletePopover(null)}>Cancel</a>
                                                 <a href="#" className='btn__assign' onClick={() => handlePublishConfirm(item)}>Confirm</a>
                                             </div>
                                         </div>
                                     </Popover>
                                 }
                             >
                                 <Button className="btn_assign" onClick={() => setOpenDeletePopover(item.id)}>
                                     <div>
                                         <Whisper placement="right" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>You Can Publish ETF Report From Here</Tooltip>} >
                                         <label className="switchSmall">
                                         <input type="checkbox" onChange={(e) => handleCheckboxChange(e, item)} checked={0} />
                                         <small></small>
                                     </label>
                                         </Whisper>
                                     </div>
                                 </Button>
                             </Whisper>
    
                                             </td>
                                         <td>
                                         <div className='company_name_td'>
                                             <span className='company_lable'>{item.symbol}</span>
                                             {item.name}
                                         </div>
                                     </td>
                                   
                                     <td style={{ textAlign: "center" }}><span  className={`tag_td ${
        item.nova_status === "" || item.nova_status === null
          ? ''
          : item.nova_status === "CMPT"
          ? 'halal_tag'
          : item.nova_status === "NCMPT"
          ? 'not_halal_tag'
          : item.nova_status === "DBTF"
          ? 'doughtful_tag'
          : item.nova_status === "UCVD"
          ? 'uncover_tag'
          : item.nova_status === "LEVERAGED"
          ? 'not_halal_tag'
          : item.nova_status === "DTER"
          ? 'data_error_tag'
          : ''
      }`}>{item.nova_status}</span></td>

<td style={{ textAlign: "center" }}><span  className={`tag_td ${
        item.musaffa_status === "" || item.musaffa_status === null
          ? ''
          : item.musaffa_status === "CMPT"
          ? 'halal_tag'
          : item.musaffa_status === "NCMPT"
          ? 'not_halal_tag'
          : item.musaffa_status === "DBTF"
          ? 'doughtful_tag'
          : item.musaffa_status === "UCVD"
          ? 'uncover_tag'
          : item.musaffa_status === "LEVERAGED"
          ? 'not_halal_tag'
          : item.musaffa_status === "DTER"
          ? 'data_error_tag'
          : ''
      }`}>{item.musaffa_status}</span></td>

<td>{item.publish_date}</td>
                                 </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center", fontSize:20, paddingTop:30, paddingBottom:30 }}>
                                    No data available
                                    </td>
                                </tr>
                            )}
                                       
                                       
                                  
                                </tbody>
                            </table>
                        </div>
)}  
                    </div>

                    <div className='etf_symbol_missing_data_col' style={{ display: isLoadingSymbol ? '' : 'flex' }}>
                        <div className='etf_symbol_missing_data_header'>
                            <h5>ETFs Symbol</h5>
                            <div className='etf_symbol_missing_data_header_right'>
                                <Button className='btn__export_report' onClick={handleETFSymbolDownload} loading={etfloading}><img src={iconExportExcel} />Export</Button>
                                <div className='dropdown_style'>
                                    <SelectPicker
                                        data={StatusManualDisableData}
                                        searchable={false}
                                        style={{ width: 120 }}
                                        onChange={handleManualStatusChange}
                                        value={manualStatusId}
                                        cleanable={false}  
                                    />
                                </div>
                            </div>
                        </div>

                        {isLoadingSymbol && ( <Placeholder.Grid rows={10} columns={4} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}

{/* Table */}
{!isLoadingSymbol && (
	
 
<>

                        <div className='etf_symbol_missing_data_header_text'>
                            <p>{etfDesc}</p>
                            <h6 className='total_etf_data'>Total Symbol: {etfCount}</h6>
                        </div>

                        <div className='etf_symbold_wrap'>
                            <ul className='etf_symbold_list'>
                            
                            {etfList.length > 0 ? (
                                etfList.map((item, index) => (
                                    <li key={index}>
                                        <Link to={`/ETFHolding/${item}`}>{item}</Link> {/* Dynamically setting ETF name */}
                                    </li>
                                ))
                            ) : (
                                <li>-</li> // Default fallback when list is empty
                            )}
                           
                            </ul>
                        </div>
                        </>    
    
     	)} 
                    </div>
                </div>
            </div>
           </Wrap>
            </ChakraProvider>
        </>
    );
}

export default ETFAnalytics;
